module.exports = __webpack_public_path__ + "img/card-specialists-hover.9c9c0d4b.svg";